import React from 'react';
import { getUserImageUrl } from '../utils/imageHelper';
import '../styles/avatar.scss';

interface UserAvatarProps {
  imageUrl?: string | null;
  name?: string | null;
  size?: 'sm' | 'md' | 'lg';
  isDeceased?: boolean;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  imageUrl,
  name,
  size = 'md',
  isDeceased = false,
}) => {
  const resolvedUrl = getUserImageUrl(imageUrl);

  return (
    <div className={`user-avatar user-avatar--${size} ${isDeceased ? 'user-avatar--deceased' : ''}`} title={name}>
      {resolvedUrl ? (
        <img src={resolvedUrl} alt={name ? `Ảnh đại diện của ${name}` : 'Ảnh đại diện'} />
      ) : (
        <div className="user-avatar__placeholder">
          <i className="fas fa-user"></i>
        </div>
      )}
    </div>
  );
};
